import { useTranslation } from '@compilorama/polang';
import translations from './use-url.t.js';

export const useUrl = () => {
  const { t } = useTranslation(translations);

  return {
    blogUrl: t('blog'),
    veedgeeUrl: t('veedgee')
  };
};
